import React,{useContext,useEffect, useState, useRef,useReducer, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon,DeleteIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';

export default function MachineTypeAdd({machine_type, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);

    const [formMachineType,setFormMachineType] = useState(machine_type);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);


    function addNewMachine(){
        dispatch({type:'create_new_tab',name: t('MachineTypeList.Tab.New'), translationKey: 'MachineTypeList.Tab.New', legacyLabel: t('MachineTypeList.Tab.New'),page:'MachineTypeAdd',props:{machine_type: null,type:'add'},mask:'gset016'})
    }

    function copyMachine(){
        dispatch({type:'create_new_tab',name: t('MachineTypeList.Tab.New'), translationKey: 'MachineTypeList.Tab.New', legacyLabel: t('MachineTypeList.Tab.New'),page:'MachineTypeAdd',props:{machine_type: formik.values,type:'add'},mask:'gset016'})
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formMachineType==null?{
            name: '',description:''
        }:formMachineType,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value]!=null ? values[value] : "");
            }
            if(formType=="add"){
                postRequest('/api/machine_types', formData,true)
                .then((response_first) => {
                    console.log(response_first);
                    getRequest("/api/machine_types").then((response) => {
                        dispatch({type:'load_machine_types',newMachineTypes:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setFormType("edit");
                        toast?.current?.show({ severity: 'info', summary: t('MachineTypeList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/machine_types/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/machine_types").then((response) => {
                        dispatch({type:'load_machine_types',newMachineTypes:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        formik.setValues(values);
                        toast?.current?.show({ severity: 'info', summary: t('MachineTypeList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(state.machine_types, formik.values.id, setFormMachineType),
        [state.machine_types, formik.values.id]
    );

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewMachine()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyMachine()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => openFavoriteDialog(t('MachineTypeList.Tab.New'),"MachineTypeAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("MachineTypeAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col min-h-[calc(100vh-177px)] overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   {t('MachineTypeAdd.Title')}
                </h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineTypeAdd.Label.Name')}
                        </label>
                        <input
                            name='name' required
                            type="text"
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineTypeAdd.Label.Description')}
                        </label>
                        <textarea
                        name='description'
                        onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>  
                        <button type="submit" ref={submitRef} className='hidden'></button>          
            </div>
            </div>
            </div>
             </form>            
            </div>
            </> 
            );
} 